'use client'
import dynamic from 'next/dynamic'

import { useThemedToast } from '@/src/hooks/ui/useThemedToast'
import useClevertapForSrp from '@/src/hooks/analytics/clevertap/srp'

import { useHomePageSearchManager } from './hooks/useHomePageSearchManager'

// Dynamic imports for code splitting
const MobileSearchForm = dynamic(
    () => import(/* webpackChunkName: "mobile-search-form" */ './MobileSearchForm'),
    {
        ssr: true
    }
)

const DesktopSearchForm = dynamic(
    () => import(/* webpackChunkName: "desktop-search-form" */ './DesktopSearchForm'),
    {
        ssr: true
    }
)

interface SearchFormProps {
    isMobile: boolean
}

const SearchForm: React.FC<SearchFormProps> = ({ isMobile }) => {
    // Common business logic
    const searchManager = useHomePageSearchManager()
    const { showError } = useThemedToast()
    const { triggerSrpEvent } = useClevertapForSrp()

    // Conditional rendering based on server-side detection
    if (isMobile) {
        return (
            <MobileSearchForm 
                searchManager={searchManager} 
                showError={showError} 
                triggerSrpEvent={triggerSrpEvent} 
            />
        )
    }

    return (
        <DesktopSearchForm 
            searchManager={searchManager} 
            showError={showError} 
            triggerSrpEvent={triggerSrpEvent} 
        />
    )
}

export default SearchForm
